import { z } from 'zod'
import { i18n } from '../i18n'

/**
 * Phone number validation regex - accepts digits only (no + or other characters)
 */
const phoneRegex = /^\d{6,15}$/

/**
 * Login form schema
 */
export const createLoginSchema = () => {
  return z.object({
    phoneNumber: z.string().regex(phoneRegex, i18n.t('loginValidationPhoneFormat')),
    password: z.string().min(1, i18n.t('loginValidationPasswordRequired')),
  })
}

export type LoginForm = z.infer<ReturnType<typeof createLoginSchema>>

/**
 * Registration form schema
 */
export const createRegisterSchema = () => {
  return z.object({
    phoneNumber: z.string().regex(phoneRegex, i18n.t('loginValidationPhoneFormat')),
    name: z.string().min(2, i18n.t('registerValidationNameMin')),
    email: z.string().email(i18n.t('registerValidationEmailInvalid')).optional().or(z.literal('')),
    password: z.string().min(8, i18n.t('registerValidationPasswordMin')),
    confirmPassword: z.string(),
  }).refine((data) => data.password === data.confirmPassword, {
    message: i18n.t('registerValidationPasswordMismatch'),
    path: ["confirmPassword"],
  })
}

export type RegisterForm = z.infer<ReturnType<typeof createRegisterSchema>>

/**
 * Phone number schema (standalone)
 */
export const createPhoneSchema = () => {
  return z.object({
    phoneNumber: z.string().regex(phoneRegex, i18n.t('loginValidationPhoneFormat')),
  })
}

export type PhoneForm = z.infer<ReturnType<typeof createPhoneSchema>>

/**
 * Change password schema
 */
export const createChangePasswordSchema = () => {
  return z.object({
    currentPassword: z.string().min(1, i18n.t('changePasswordValidationCurrentRequired')),
    newPassword: z.string().min(8, i18n.t('registerValidationPasswordMin')),
    confirmPassword: z.string(),
  }).refine((data) => data.newPassword === data.confirmPassword, {
    message: i18n.t('registerValidationPasswordMismatch'),
    path: ["confirmPassword"],
  })
}

export type ChangePasswordForm = z.infer<ReturnType<typeof createChangePasswordSchema>>


